export default __webpack_public_path__ + "static/media/user.b06db091.jpg";